import * as Yup from 'yup'
import { Form, Row, Col } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkStateGrade, checkGrade } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    stateExamination2: checkStateGrade,
    stateExamination1: checkStateGrade,
    stateExamination1state: checkStateGrade,
    stateExamination1university: checkStateGrade,
    highschoolgrade: checkGrade
});

export const StudySubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formstateExamination2">
                    <Form.Label>2. Staatsexamen gesamt</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Punktezahl eingeben"
                        type="number"
                        name="stateExamination2"
                        value={values.stateExamination2 || ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.stateExamination2 && !errors.stateExamination2}
                        isInvalid={errors.stateExamination2}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.stateExamination2}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} controlId="formstateExamination1">
                    <Form.Label>1. Staatsexamen gesamt</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Punktezahl eingeben"
                        type="number"
                        name="stateExamination1"
                        value={values.stateExamination1 || ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.stateExamination1 && !errors.stateExamination1}
                        isInvalid={errors.stateExamination1}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.stateExamination1}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formstateExamination1state">
                    <Form.Label>1. Staatsexamen staatlicher Teil</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Punktezahl eingeben"
                        type="number"
                        name="stateExamination1state"
                        value={values.stateExamination1state || ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.stateExamination1state && !errors.stateExamination1state}
                        isInvalid={errors.stateExamination1state}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.stateExamination1state}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} controlId="formstateExamination1university">
                    <Form.Label>1. Staatsexamen universitärer Teil</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Punktezahl eingeben"
                        type="number"
                        name="stateExamination1university"
                        value={values.stateExamination1university || ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.stateExamination1university && !errors.stateExamination1university}
                        isInvalid={errors.stateExamination1university}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.stateExamination1university}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
            <Form.Group className="mb-3" controlId="formhighschoolgrade">
                <Form.Label>Abiturnote</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Abiturnote eingeben"
                    type="number"
                    name="highschoolgrade"
                    value={values.highschoolgrade || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.highschoolgrade && !errors.highschoolgrade}
                    isInvalid={errors.highschoolgrade}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.highschoolgrade}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};